import { render, staticRenderFns } from "./FanData.vue?vue&type=template&id=4b3fcc9f&scoped=true"
import script from "./FanData.vue?vue&type=script&lang=js"
export * from "./FanData.vue?vue&type=script&lang=js"
import style0 from "./FanData.vue?vue&type=style&index=0&id=4b3fcc9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fcc9f",
  null
  
)

export default component.exports